import styles from './CourseQuote.module.css'
// https://fkhadra.github.io/react-toastify/introduction/
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Quote1 = () => (
  <>
    <p className={styles.Quote}>
      I counted and 80 lessons out of 110 in the "Cypress Network Testing
      Course" had something new I did not know before. It is an insane value!
    </p>
    <p className={styles.Author}>
      Murat K Ozcan, Cypress Ambassador, author of{' '}
      <a href="https://muratkerem.gitbook.io/">
        CCTDD: Cypress Component Test Driven Design
      </a>
    </p>
  </>
)

const Quote2 = () => (
  <>
    <p className={styles.Quote}>
      Even though I don't consider myself a beginner I needed to scoop up
      "Testing The Swag" course. The great thing about Gleb's courses is that
      you can't help but learn something new in each lesson.
    </p>
    <p className={styles.Author}>
      Aaron Harvey, Director of Quality Assurance at Neptune Flood Insurance
    </p>
  </>
)

const Quote3 = () => (
  <>
    <p className={styles.Quote}>
      Wrapped up Testing the Swag Store. About to start Network Testing
      Exercises. Just want to thank you again! Your a goldmine of knowledge. I'm
      a QA Engineer and before the year is up I WILL be working in Automation!
    </p>
    <p className={styles.Author}>Brian Estrada, a happy student</p>
  </>
)

const Quote4 = () => (
  <>
    <p className={styles.Quote}>
      I am trying to purchase more courses... It's like a child in a sweet shop
      so many things to go over. I've only done 2 [lessons from this course] but
      love it already
    </p>
    <p className={styles.Author}>Ciprian, Senior Automation Test Analyst</p>
  </>
)

export default function CourseQuote() {
  const quoteRoll = Math.random()
  const Quote =
    quoteRoll < 0.25
      ? Quote1
      : quoteRoll < 0.5
      ? Quote2
      : quoteRoll < 0.75
      ? Quote3
      : Quote4
  const method = Math.random() < 0.5 ? toast.info : toast.success
  method(<Quote />, {
    position: toast.POSITION.BOTTOM_LEFT,
    autoClose: false,
  })

  return <ToastContainer />
}
